import { FilterField } from '@totem/components/ui_components/reportSettings/types';

export const STATUS_OPEN = 'OPEN';

export const statusOptions = [
  { text: 'Open', value: 'OPEN' },
  { text: 'Merged', value: 'MERGED' },
  { text: 'Dismissed', value: 'DISMISSED' },
  { text: 'Superseded', value: 'SUPERSEDED' },
];

export const deviceSyncMergesContainerConfiguration: FilterField[] = [
  {
    key: 'device',
    label: 'Device',
    sortField: 'devices.displayName',
    filterField: 'devices.displayName',
    multiple: false,
    operator: 'cscontains',
    values: [],
  },
  {
    key: 'organization',
    label: 'Organization',
    sortField: 'organizationName',
    filterField: 'organizationId',
    multiple: true,
    values: [],
  },
  {
    key: 'occurrences',
    label: 'Occurrences',
    sortField: 'occurrences',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'firstSeen',
    label: 'First Seen',
    sortField: 'firstSeen',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'lastSeen',
    label: 'Last Seen',
    sortField: 'lastSeen',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'status',
    label: 'Status',
    sortField: 'status',
    filterField: 'status',
    multiple: true,
    values: [],
    options: statusOptions,
  },
];
